import { render } from "./General.vue?vue&type=template&id=0b49816d"
import script from "./General.vue?vue&type=script&lang=js"
export * from "./General.vue?vue&type=script&lang=js"

import "./General.vue?vue&type=style&index=0&id=0b49816d&lang=scss"

import exportComponent from "/builds/clients/stanovak/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__